import { render, staticRenderFns } from "./private-messages.vue?vue&type=template&id=1b31ec32&scoped=true&"
import script from "./private-messages.vue?vue&type=script&lang=js&"
export * from "./private-messages.vue?vue&type=script&lang=js&"
import style0 from "./private-messages.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./private-messages.vue?vue&type=style&index=1&id=1b31ec32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31ec32",
  null
  
)

export default component.exports